import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { ProjectView } from '@/features/project/ProjectView';

export const Route = createFileRoute('/projects/$id')({
  component: ProjectPage,
});

function ProjectPage() {
  const { id } = Route.useParams();
  return (
    <AppShell>
      <ProjectView projectId={id} />
    </AppShell>
  );
}
